import * as React from 'react';
import { IComplaint } from '../../../../api/complaint';
import { ComplaintItemContainer } from './item/container';
import * as styles from './index.css';
import { getSelectedComplaint } from './helpers';

export interface IComplaintItemProps {
  selectionTree: number[];
  complaints: IComplaint[];
  selected: number | undefined;
  onClickOnPrevButton(): void;
  onSelect(index: number, isDropdown?: boolean): void;
  onClickOnContainer(e: React.MouseEvent<HTMLDivElement>): void;
}

export const ComplaintItem = ({
  selectionTree,
  complaints,
  selected,
  onClickOnContainer,
  onClickOnPrevButton,
  onSelect,
}: IComplaintItemProps) => {
  const selectedComplaint = getSelectedComplaint(complaints, selectionTree);
  const selectedComplaints = (selectedComplaint && selectedComplaint.items) || complaints;

  return (
    <div className={styles['container']} onClick={onClickOnContainer}>
      {selectionTree.length > 0 && (
        <button className={styles['back']} onClick={onClickOnPrevButton}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.925 10" width="6" height="10">
            {/* tslint:disable-next-line:max-line-length */}
            <path
              fill="currentColor"
              d="M.29 4.342L4.297.182c.474-.324 1.12-.204 1.446.27.23.334.244.77.037 1.12L2.495 5.06 5.78 8.43c.29.496.126 1.134-.37 1.425-.347.203-.78.19-1.113-.038L.29 5.66C.13 5.496.03 5.287 0 5.062c0-.27.104-.527.29-.72z"
            />
          </svg>
        </button>
      )}
      <h3 className={styles['title']}>
        Шаг {selectionTree.length + 1}. {!selectedComplaint ? 'На что жалуетесь?' : selectedComplaint.title}
      </h3>
      <ul className={styles['links']}>
        {selectedComplaints.map((complaint, index) => (
          <ComplaintItemContainer
            step={selectionTree.length}
            index={index}
            onSelect={onSelect}
            isSelected={selected === index}
            complaint={complaint}
            key={`complaint-${complaint.id}`}
          />
        ))}
      </ul>
    </div>
  );
};
